import ShoppingCartRoundedIcon from '@mui/icons-material/ShoppingCartRounded';
import { Tooltip } from '@mui/material';
import { OfferType } from '../types/PartnerTypes';

export default function OfferCarousel({ offers, partnerId }: { offers: OfferType[], partnerId: string }) {
   

    const handleIconClick = (offer: OfferType) => {
        // console.log(`Offer clicked: ${offer.BuzzName}`);
        window.location.href = `https://www.plundr.besaksham.com/details/${partnerId}/offer/${offer.id}`;
    };

    return (<section>
        <div className="mx-auto max-w-screen-xl px-0 py-4 sm:px-6 sm:py-4 lg:px-0">
            <div className="grid grid-cols-1 gap-4 lg:grid-cols-4 lg:items-stretch">
                <div className="grid place-content-center rounded-lg bg-gray-800  p-4 sm:p-8">
                    <div className="mx-auto max-w-md text-center lg:text-left">
                        <header>
                            <h2 className="text-xl font-semibold text-gray-100 sm:text-3xl">Offers</h2>

                            <p className="mt-2 sm:mt-4 text-gray-300">
                                Steal-worthy deals just for you! Grab it before they're gone.
                            </p>
                        </header>

                    </div>
                </div>

                <div className="lg:col-span-3 lg:py-4">
                    {offers.length > 0 ? (
                        <div className="flex overflow-x-auto pb-4 diff-scrollbar">
                            <ul className="flex gap-4">
                                {offers.map((offer, index) => {
                                    return (
                                        <li key={index}>
                                            <article  onClick={()=>handleIconClick(offer)} className="rounded-xl cursor-pointer bg-white p-3 shadow-lg border border-gray-300 hover:shadow-xl">
                                                <div className="relative flex items-end overflow-hidden rounded-xl">
                                                    <div className="relative w-full h-40 sm:h-52 aspect-[16/10]"> {/* Set a fixed height for landscape */}
                                                        <img
                                                            src={offer.url}
                                                            alt="Hotel Photo"
                                                            className="object-cover w-full h-full transition-transform duration-300 transform hover:scale-105" // Added zoom effect on hover
                                                        />
                                                    </div>
                                                    <div className={`absolute top-3 right-3 inline-flex items-center rounded-xl ${offer.isLive ? "bg-green-600" : "bg-red-600"} px-2.5 shadow-2xl py-1  `}>
                                                        <span className="text-white ml-1 text-sm font-semibold">{offer.isLive ? "Live" : "Expired"}</span>
                                                    </div>
                                                </div>

                                                <div className="mt-1 p-2">
                                                    <div className="overflow-wrap">
                                                        <h2 className="text-slate-700 font-semibold">{offer.BuzzName}</h2>
                                                    </div>
                                                    <div className="h-[2.5rem] flex items-center">
                                                        <p className="text-slate-600 mt-1 text-sm line-clamp-2 max-w-60">{offer.Description}</p>
                                                    </div>

                                                    <p className="text-slate-400 mt-1 text-sm">Offer Applicabe on - <span className='font-semibold text-slate-900'>{offer.offerConstraint}</span></p>
                                                    <p className="text-slate-400 mt-1 text-sm">Offer Code -  <span className='font-semibold text-slate-900'>{offer.OfferCode}</span></p>
                                                    <p className='text-slate-400 mt-1 text-sm'>Validity -   <span className='font-semibold text-slate-900'>{offer.StartDate && offer.EndDate
                                                        ? `${new Date(offer.StartDate.seconds * 1000).toLocaleDateString('en-GB', {
                                                            day: '2-digit',
                                                            month: '2-digit',
                                                            year: 'numeric'
                                                        })} - ${new Date(offer.EndDate.seconds * 1000).toLocaleDateString('en-GB', {
                                                            day: '2-digit',
                                                            month: '2-digit',
                                                            year: 'numeric'
                                                        })}` 
                                                        : 'Not specified'}</span></p>
                                                    <div className="mt-3 flex items-end justify-between">
                                                        <p>
                                                            <span className="text-lg font-bold text-blue-500">
                                                                {offer.Price ? `₹ ${offer.Price}` : (
                                                                    <span className="bg-green-100 text-green-600 px-2 py-1 rounded-lg">FREE</span>
                                                                )}
                                                            </span>
                                                        </p>

                                                        <Tooltip title={offer.isLive ? "Buy Now" : "Expired"} arrow>
                                                            <div className={`group inline-flex rounded-xl ${offer.isLive ? "bg-blue-100 hover:bg-blue-200" : "bg-gray-100"} p-2`}>
                                                                <ShoppingCartRoundedIcon 
                                                                    fontSize='small' 
                                                                    style={{ color: offer.isLive ? '#4284E2' : '#9CA3AF' }} 
                                                                />
                                                            </div>
                                                        </Tooltip>
                                                    </div>
                                                </div>
                                            </article>
                                        </li>
                                    )
                                })}


                            </ul>
                        </div>
                    ) : (
                        <div className="flex h-full min-h-[100px] sm:min-h-[300px] items-center justify-center bg-white rounded-xl">
                            <p className="text-xl text-gray-500">More exciting offers coming soon!</p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    </section>)

}
